import { Icon, IconButton, Tooltip } from "@familyzone/component-library";
import React, { FC } from "react";
import { zIndices } from "../utils/ZIndexUtil";

interface Props {
  tooltipText: string;
  placement?:
    | "top-end"
    | "top"
    | "top-start"
    | "right-start"
    | "right"
    | "right-end"
    | "bottom-start"
    | "bottom"
    | "bottom-end"
    | "left-start"
    | "left"
    | "left-end";
  maxWidth?: string | number;
  whiteSpace?: "normal" | "nowrap" | "pre" | "pre-line" | "pre-wrap";
}

export const InfoIconV3: FC<Props> = ({ tooltipText, placement = "right", maxWidth = "160px", ...props }) => (
  <Tooltip variant="dark" placement={placement} hasArrow label={tooltipText} zIndex={zIndices.tooltip} maxWidth={maxWidth} {...props}>
    <IconButton
      variant="ghost"
      size="sm"
      icon={<Icon variant="solid" color="neutrals.80" icon="fa-info-circle" />}
      aria-label={tooltipText}
    />
  </Tooltip>
);
